"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var PromotionPerformanceRowsDataDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionPerformanceRowsDataDTOConverter, _DataObjectConverter_);

  function PromotionPerformanceRowsDataDTOConverter() {
    _classCallCheck(this, PromotionPerformanceRowsDataDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceRowsDataDTOConverter).apply(this, arguments));
  }

  return PromotionPerformanceRowsDataDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionPerformanceRowsDataDTOConverter = PromotionPerformanceRowsDataDTOConverter;